/**
 * Gli URL yt possono essere in diversi formati, l'ID dei video è sempre formato da 11 caratteri
 * 
 * Utility YouTube:
 *   Estrae l'ID video dagli URL.
 *   Costruisce la thumbnail.
 *   Sostituisce l'immagine con la copertina del video yt quando tipo === 'L'.
 *
 * Formati supportati:
 *   https://www.youtube.com/watch?v=XXXXXXXXXXX
 *   https://youtu.be/XXXXXXXXXXX
 *   https://www.youtube.com/embed/XXXXXXXXXXX
 *   https://www.youtube.com/v/XXXXXXXXXXX
 *   https://www.youtube.com/shorts/XXXXXXXXXXX
 */

const YT_ID_RE =
  /(?:youtube\.com\/(?:watch\?.*v=|embed\/|v\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/i

/**
 * Estrae l'ID del video yt da un URL.
 *   Prova a usare l'API URL per leggere il parametro ?v=
 *   Se non funziona (URL non assoluto o senza v), ripiega sulla regex YT_ID_RE
 */
function extractYoutubeId(url) {
  if (!url) return null
  try {
    const u = new URL(url)
    const v = u.searchParams.get('v')
    if (v && v.length === 11) return v
  } catch {}
  const m = String(url).match(YT_ID_RE)
  return m ? m[1] : null
}
/**
 * Costruisce l'URL della copertina di un video yt.
 *   'default'  -> default.jpg     (bassa)
 *   'mq'       -> mqdefault.jpg   (media)
 *   'hq'       -> hqdefault.jpg   (alta)  [DEFAULT]
 *   'maxres'   -> maxresdefault.jpg (massima: non sempre disponibile)
 * Le stringhe hanno la sintassi aspettata dal CDN (Content Delivery Network) di yt 
 */
function youtubeThumb(url, variant = 'hq') {
  const id = extractYoutubeId(url)
  if (!id) return null

  let file
  switch (variant) {
    case 'maxres':
      file = 'maxresdefault.jpg'
      break
    case 'mq':
      file = 'mqdefault.jpg'
      break
    case 'default':
      file = 'default.jpg'
      break
    case 'hq':
    default:
      file = 'hqdefault.jpg'
      break
  }
  return `https://i.ytimg.com/vi/${id}/${file}`
}
/**
 * Restituisce un nuovo array di oggetti photos:
 *   se tipo === 'L' il campo 'allegato' viene sostituito con la copertina.
 *   altrimenti restituisce l'oggetto originale
 */
function withYtThumb(items, variant = 'hq') {
  return (items ?? []).map((p) => {
    if (p?.tipo === 'L') {
      const thumb = youtubeThumb(p.allegato, variant)
      return { ...p, allegato: thumb || p.allegato }
    }
    return p
  })
}

export function useYtThumb() {
  return { extractYtId: extractYoutubeId, ytThumb: youtubeThumb, withYtThumb }
}